const common = {
  nav: {
    categories: "Categories",
    guides: "Guides",
    shipping: "Shipping",
    qc: "QC",
    reviews: "Reviews",
    comparisons: "Comparisons",
    safety: "Safety",
    contact: "Contact",
    about: "About",
    products: "Products",
  },

  languages: {
    en: "English",
    fr: "Français",
    da: "Dansk",
    de: "Deutsch",
  },

  hero: {
    h1: "AllChinaBuy Spreadsheet — Discover Products, Finds & Buying Resources",
    subtitle: "Explore the latest AllChinaBuy spreadsheet resources, product finds, buying guides, shipping information, QC tips and trusted resources — organized in one place.",
    primaryCta: "Explore AllChinaBuy Spreadsheet",
    secondaryCta: "Browse Buying Guides",
    trustText: "Independent resource • Multilingual guides • Updated content",
    mainCta: "Visit Main Website",
  },

  categories: {
    title: "Shop Categories",
    shoes: "Shoes",
    hoodies: "Hoodies/Sweaters",
    tshirts: "T-Shirts",
    jackets: "Jackets",
    pants: "Pants/Shorts",
    headwear: "Headwear",
    sets: "Sets",
    underwear: "Underwear/Underpants",
    jersey: "Jersey",
    accessories: "Accessories",
    bags: "Bags",
    belts: "Belts",
    perfumes: "Perfumes",
    other: "Other Stuff",
  },

  whatIs: {
    h2: "What Is the AllChinaBuy Spreadsheet?",
    description: "The AllChinaBuy Spreadsheet is a convenient way to discover organized product resources, product links, categories and buying information. Instead of searching across multiple sources, use our resource hub to explore AllChinaBuy-related products, guides and practical buying information in one place.",
    cta: "Explore the Spreadsheet",
  },

  resources: {
    h2: "Explore Popular AllChinaBuy Resources",
    spreadsheet: "AllChinaBuy Spreadsheet",
    finds: "AllChinaBuy Finds",
    products: "AllChinaBuy Products",
    shippingResource: "AllChinaBuy Shipping",
    qcResource: "AllChinaBuy QC",
    warehouse: "AllChinaBuy Warehouse",
    review: "AllChinaBuy Review",
    coupon: "AllChinaBuy Coupon",
  },

  guides: {
    h2: "AllChinaBuy Buying Guides",
    reviewGuide: "AllChinaBuy Review",
    shippingCost: "Shipping Cost Guide",
    warehouseGuide: "Warehouse Guide",
    qcGuide: "QC Guide",
    safetyGuide: "Safety Guide",
    couponGuide: "Coupon Guide",
  },

  latestFinds: {
    h2: "Latest AllChinaBuy Finds",
    cta: "Explore AllChinaBuy Finds",
  },

  shipping: {
    h2: "AllChinaBuy Shipping, QC & Warehouse Information",
    description: "Understand AllChinaBuy shipping options, warehouse processes, and quality control considerations before placing your order. Our guides cover shipping methods, potential costs, tracking, and risk management tips.",
  },

  comparison: {
    h2: "AllChinaBuy Comparisons",
    description: "Compare AllChinaBuy with other popular shopping agents to make an informed decision about your buying experience.",
  },

  safety: {
    h2: "Is AllChinaBuy Legit and Safe?",
    description: "We provide neutral, evidence-based guidance on AllChinaBuy safety, legitimacy, and risk factors. Our safety guide covers payment security, seller verification, and buyer protection tips.",
    cta: "Read the AllChinaBuy Safety Guide",
  },

  whyUs: {
    h2: "Why Use Our AllChinaBuy Spreadsheet Hub?",
    organized: "Organized Resources",
    organizedDesc: "All product links, categories, and guides in one convenient place.",
    discovery: "Easy Product Discovery",
    discoveryDesc: "Find what you need quickly without searching multiple sites.",
    practical: "Practical Guides",
    practicalDesc: "Step-by-step buying guides, shipping tips, and QC advice.",
    shippingInfo: "Shipping Information",
    shippingInfoDesc: "Understand shipping methods, costs, and timelines before you buy.",
    multilingual: "Multilingual Content",
    multilingualDesc: "Access guides in English, French, Danish, and German.",
    updated: "Regular Updates",
    updatedDesc: "Our content is updated regularly to reflect the latest information.",
  },

  bottomCta: {
    h2: "Start Exploring AllChinaBuy",
    primaryCta: "Explore AllChinaBuy Spreadsheet",
    secondaryCta: "Visit Main Website",
    description: "Explore the complete AllChinaBuy spreadsheet, browse curated product finds, and access detailed buying guides in your preferred language.",
  },

  articles: {
    h2: "AllChinaBuy Spreadsheet Articles",
    readMore: "Read Article",
  },

  footer: {
    disclaimer: "Disclaimer: This is an independent informational resource and is not the official AllChinaBuy website. AllChinaBuy is a trademark of its respective owners.",
    spreadsheet: "AllChinaBuy Spreadsheet",
    resources: "Resources",
    categories: "Categories",
    guides: "Guides",
    reviews: "Reviews",
    shipping: "Shipping",
    warehouse: "Warehouse",
    qc: "QC",
    comparisons: "Comparisons",
    safety: "Safety",
    about: "About",
    contact: "Contact",
    privacy: "Privacy Policy",
    terms: "Terms of Service",
    editorial: "Editorial Policy",
    language: "Language",
    copyright: "© 2026 AllChinaBuy Spreadsheet Hub. All rights reserved.",
  },

  common: {
    readMore: "Read More",
    learnMore: "Learn More",
    explore: "Explore",
    view: "View",
    updated: "Updated",
  },

  allChinaBuy: {
    title: "AllChinaBuy Spreadsheet",
    buyNow: "Buy It Now",
  },

  products: {
    title: "All Products",
    description: "Browse our curated collection of AllChinaBuy products. Click any item to visit the product page and purchase through kaspreadsheet.com.",
    disclaimer: "This is an independent resource. Products link to kaspreadsheet.com for purchase.",
    filterAll: "All Categories",
    searchPlaceholder: "Search products...",
    productCount: "{{count}} product",
    productCount_plural: "{{count}} products",
    noResults: "No products found",
    noResultsDesc: "Try adjusting your search or category filter",
    clearFilters: "Clear Filters",
    buyNow: "Buy Now",
    buy: "Buy",
    viewAll: "View All Products",
    moreProducts: "Looking for more products?",
    moreProductsDesc: "Visit the main kaspreadsheet.com website for the complete catalog with thousands more products.",
  },

  meta: {
    siteTitle: "AllChinaBuy Spreadsheet Hub — Product Finds & Buying Guides",
    description: "Your independent resource hub for AllChinaBuy spreadsheet resources, product finds, buying guides, shipping information, and QC tips. Explore organized categories and guides in multiple languages.",
  },

  article: {
    home: "Home",
    lastUpdated: "Last updated",
    disclaimer: "Disclaimer",
    disclaimerText: "This is an independent informational resource and is not the official AllChinaBuy website. All information provided is for educational purposes only. Always verify details directly with sellers before making purchases.",
    faqTitle: "Frequently Asked Questions",
    readyToExplore: "Ready to start exploring?",
    ctaDesc: "Visit the main AllChinaBuy website to browse the full product catalog and start shopping.",
    relatedArticles: "Related Articles",
    backToHome: "Back to Homepage",
    ctaText: "Continue to Main Website",
  },
};

export default common;